import { Container } from "@mui/material";
import { styled } from "@mui/system";
import Title from "src/components/common/Title";
import MaintenanceBlock from "src/components/maintenance/MaintenanceBlock";
import Disclaimer from "src/components/trade/Disclaimer";
import TradeCard from "src/components/trade/tradeV2/TradeCard";
import { useMaintenanceState } from "src/store/features/maintenance.slice";
import Layout from "../components/core/Layout";
import TradeSuccess from "src/components/trade/TradeSuccess";
import React, { useReducer } from "react";
import { useUserSlice } from "src/store/features/user.slice";
import RecentTradesV2 from "src/components/trade/tradeV2/RecentTradesV2";
import CryptoRiskWarning from "src/components/disclosures/CryptoRiskWarning";
import { trackEvent } from "src/Amplitude";

export const TitleWrapper = styled("div")(({ theme }) => ({}));

export const ComponentWrapper = styled("div")(({ theme }) => ({
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "space-between",
  padding: "16px 0px",
  gap: "22px",

  [theme.breakpoints.down(1200)]: {
    flexDirection: "column",
    "& > div": {
      width: "100%",
    },
  },
}));

export const TradeWrapper = styled("div")(({ theme }) => ({
  display: "flex",
  flex: 2,
  minHeight: "541px",
  justifyContent: "center",
  alignItems: "flex-start",
}));

export const RecentTradesWrapper = styled("div")(({ theme }) => ({
  width: "340px",
  height: "541px",
}));

export const RecentTradeComp = styled("div")(({ theme }) => ({
  width: "100%",
  height: "100%",
  borderRadius: "30px",
  background: "#002035",
  boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
}));

export const DisclaimerWrapper = styled("div")(({ theme }) => ({
  width: "100%",
  display: "flex",
  justifyContent: "center",
}));

const TradeV2 = () => {
  const { tradecontroller } = useMaintenanceState();
  const { broker } = useUserSlice();

  const title = {
    partA: `Swap with`,
    partB: "caleb & brown",
  };
  const subtitle = "Place your order below and your broker will handle the rest.";

  const [openTradeSuccess, toggleTradeSuccessComponent] = useReducer(
    (isSuccess) => !isSuccess,
    false,
  );

  React.useEffect(() => {
    trackEvent("Visit Page", { page: "Trade" });
  }, []);

  return (
    <Layout>
      {!tradecontroller && <MaintenanceBlock page={"trade"} />}
      <Container sx={{ padding: { md: "0px 100px" } }}>
        {/* Title */}
        <TitleWrapper>
          <Title title={title} subtitle={subtitle} />
        </TitleWrapper>

        {/* UK-only high-risk warning */}
        <CryptoRiskWarning />

        <ComponentWrapper>
          {/* Trade Component */}
          <TradeWrapper>
            {openTradeSuccess ? (
              <TradeSuccess toggle={toggleTradeSuccessComponent} broker={broker} />
            ) : (
              <TradeCard toggleTradeSuccess={toggleTradeSuccessComponent} />
            )}
          </TradeWrapper>

          {/* Recent Trades Component */}
          <RecentTradesWrapper>
            <RecentTradesV2 />
          </RecentTradesWrapper>

          {/* Disclaimer Component */}
          <DisclaimerWrapper>
            <Disclaimer />
          </DisclaimerWrapper>
        </ComponentWrapper>
      </Container>
    </Layout>
  );
};

export default TradeV2;
